import LockConfiguration from "./Configurations/LockConfiguration"
import InnerAndOuterLength from "./Configurations/InnerAndOuterLength"
import SimpleConfiguration from "./Configurations/SimpleConfiguration"
import SystemAndLengthSelection from "./Configurations/SystemAndLengthSelection"
import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
} from "@secureo/common/reducers/productDetailPageReducer"

const ConfigurationsHandler = ({ accessToken, reducerState, dispatch }: Props) => {
	const { productType, variantsByVariantId, cylinderConfigurationType } = reducerState

	const hasVariants = Object.keys(variantsByVariantId).length > 1

	const showSimpleConfiguration = productType === "simpleConfigurationProduct" && hasVariants
	const showLockConfiguration = productType === "Safe" && hasVariants
	const showSystemAndLengthSelection = [
		"outerLengthsBySystem",
		"systems",
		"lengthCombinationsBySystem",
	].includes(cylinderConfigurationType)
	const showInnerAndOuterLength = ["innerLengthsByOuterLengths", "outerLengths"].includes(
		cylinderConfigurationType,
	)

	if (showSimpleConfiguration)
		return <SimpleConfiguration reducerState={reducerState} dispatch={dispatch} />

	if (showLockConfiguration)
		return <LockConfiguration reducerState={reducerState} dispatch={dispatch} />

	if (showSystemAndLengthSelection) {
		return (
			<SystemAndLengthSelection
				accessToken={accessToken}
				reducerState={reducerState}
				dispatch={dispatch}
			/>
		)
	}

	if (showInnerAndOuterLength) {
		return (
			<InnerAndOuterLength
				accessToken={accessToken}
				reducerState={reducerState}
				dispatch={dispatch}
			/>
		)
	}

	return null
}

interface Props {
	accessToken: string
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
}

export default ConfigurationsHandler
